export const footerColumns = [
  {
    heading: "Services",
    links: [
      { name: "AI Consulting", url: "https://kanerika.com/services/ai/" },
      { name: "Generative AI", url: "https://kanerika.com/services/generative-ai/" },
      { name: "Agentic AI", url: "https://kanerika.com/services/agentic-ai/" },
      { name: "Data Analytics", url: "https://kanerika.com/services/data-analytics/" },
      { name: "Data Governance", url: "https://kanerika.com/services/data-governance/" },
      { name: "Data Integration", url: "https://kanerika.com/services/data-integration/" },
      { name: "Intelligent Automation", url: "https://kanerika.com/services/rpa/" },
      { name: "Migration", url: "https://kanerika.com/services/migration/" },
    ],
  },
  {
    heading: "Business Functions",
    links: [
      { name: "Sales", url: "https://kanerika.com/business-functions/sales/" },
      { name: "Finance", url: "https://kanerika.com/business-functions/finance/" },
      { name: "Supply Chain", url: "https://kanerika.com/business-functions/supply-chain/" },
      { name: "Operations", url: "https://kanerika.com/business-functions/operations/" },
    ],
  },
  {
    heading: "Industries",
    links: [
      { name: "BFSI", url: "https://kanerika.com/industries/bfsi/" },
      { name: "Logistics & Supply Chain", url: "https://kanerika.com/industries/logistics-and-supply-chain/" },
      { name: "Manufacturing", url: "https://kanerika.com/industries/manufacturing/" },
      { name: "Retail & FMCG", url: "https://kanerika.com/industries/retail-and-fmcg/" },
    ],
  },
  {
    heading: "Company",
    links: [
      { name: "Careers", url: "https://kanerika.com/careers/" },
      { name: "Partners", url: "https://kanerika.com/partners/" },
    ],
  },
  {
    heading: "Company",
    hiddenHeading: true,
    links: [
      { name: "Blogs", url: "https://kanerika.com/resources/blogs/" },
      { name: "Events & Webinars", url: "https://kanerika.com/resources/events-and-webinars/" },
      { name: "Submit Guest Blog", url: "https://kanerika.com/submit-guest-blog/" },
    ],
  },
];

export const badgesLine1 = [
  { name: "GoodsFirms", url: "https://www.goodfirms.co/company/kanerika-inc", image: "/images/footer/GoodsFirms.svg", height: "42px" },
  { name: "CMMI", url: "https://pars.cmmiinstitute.com/appraisals/71370", image: "/images/footer/CMMI.svg", height: "42px" },
  { name: "Clutch", url: "https://clutch.co/profile/kanerika", image: "/images/footer/Clutch-Light.svg", height: "42px" },
  { name: "Capterra", url: "https://www.capterra.in/software/1062440/flip", image: "/images/footer/Capterra-Light.svg", height: "42px" },
];

export const badgesLine2 = [
  { name: "Glassdoor", url: "https://www.glassdoor.co.in/Reviews/Kanerika-Software-Reviews-E1319224.htm", image: "/images/footer/Glassdoor-Logo.svg", height: "42px" },
  { name: "G2 badge", url: "https://www.g2.com/sellers/kanerika", image: "/images/footer/Asset-20-1.svg", height: "52px" },
  { name: "50PROS", url: "https://www.50pros.com/agency/kanerika?utm_source=widget&utm_medium=embed&utm_campaign=global-award", image: "/images/footer/50PROS.svg", height: "52px" },
  { name: "Great Place To Work", url: "https://www.greatplacetowork.in/great/company/kanerika-inc", image: "/images/footer/Great-Place-To-Work.svg", height: "42px" },
];

export const legalLinks = [
  { name: "Privacy Policy", url: "https://kanerika.com/privacy-policy/" },
  { name: "DPA", url: "https://kanerika.com/dpa/" },
  { name: "Terms and Conditions", url: "https://kanerika.com/terms-and-conditions/" },
  { name: "Sitemap", url: "https://kanerika.com/sitemap_index.xml" },
];
